module.exports = __webpack_public_path__ + "img/accessory_shirt_03.43c3b307.svg";